import type { CSSProperties } from 'react';

const PALETTE = [
  'oklch(60% 0.15 25)', 'oklch(60% 0.15 75)', 'oklch(60% 0.15 150)', 'oklch(60% 0.15 200)',
  'oklch(60% 0.15 250)', 'oklch(60% 0.15 280)', 'oklch(60% 0.15 320)', 'oklch(60% 0.15 0)',
  'oklch(60% 0.15 100)', 'oklch(60% 0.15 180)',
];

export type Presence = 'available' | 'oncall' | 'acw' | 'break' | 'training' | 'offline';

const PRESENCE_COLORS: Record<Presence, string> = {
  available: 'var(--ok)',
  oncall: 'var(--info)',
  acw: 'var(--warn)',
  break: 'var(--muted)',
  training: 'var(--busy)',
  offline: 'var(--faint)',
};

export interface AvatarProps {
  name?: string;
  idx?: number;
  size?: number;
  presence?: Presence;
  src?: string | null;
  className?: string;
}

export function Avatar({ name = '?', idx = 0, size = 32, presence, src, className }: AvatarProps) {
  const initials = (name || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase();

  const bgColor = PALETTE[idx % PALETTE.length];

  const wrapStyle: CSSProperties = {
    position: 'relative',
    display: 'inline-flex',
    flexShrink: 0,
  };

  const avatarStyle: CSSProperties = {
    width: size,
    height: size,
    borderRadius: 'var(--r-pill)',
    background: bgColor,
    color: 'var(--on-accent)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: Math.max(10, Math.floor(size * 0.4)),
    backgroundImage: src ? `url(${src})` : undefined,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <span style={wrapStyle} className={className} aria-label={name}>
      <span style={avatarStyle}>{!src && initials}</span>
      {presence && (
        <span
          style={{
            position: 'absolute',
            insetInlineEnd: -2,
            bottom: -2,
            width: Math.max(8, size / 4),
            height: Math.max(8, size / 4),
            borderRadius: '50%',
            background: PRESENCE_COLORS[presence],
            border: '2px solid var(--surface)',
          }}
          aria-label={presence}
        />
      )}
    </span>
  );
}
